type Props = {step: number; totalSteps: number};

export function FlowProgress({step, totalSteps}: Props) {
  return (
    <div className='flex gap-1.5 mb-10'>
      {Array.from({length: totalSteps}).map((_, i) => (
        <div
          key={i}
          className={`h-0.5 flex-1 rounded-full transition-colors duration-300 ${
            i <= step ? 'bg-iq-black' : 'bg-iq-grey-light'
          }`}
        />
      ))}
    </div>
  );
}
